<template>
  <el-dialog
    title="批量修改"
    :visible.sync="changeTimeVisible"
    width="500px"
    :before-close="closeChangeTimeDia"
    :close-on-click-modal="false"
    class="audit-info"
    append-to-body
  >
    <div class="audit-cont">
      <el-form class="search-form" :model="timeForm" ref="timeForm" size="small" :rules="timeRules">
        <el-row>
          <el-col :span="12">
            <el-form-item label-width="142px" label="期望到货日期：" prop="time">
              <el-date-picker
                v-model="timeForm.time"
                type="date"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerReleaseTimeDate"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="handle-btn">
        <eui-btn   type="secondary" @click="closeChangeTimeDia">取消</eui-btn>
        <eui-btn   type="primary" @click="submitChangeTime">提交</eui-btn>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import EuiBtn from "epec-ui/src/package/eui-btn/index";
export default {
  components: {EuiBtn},
  props: {
    changeTimeVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      timeForm: {
        time: '',
      },
      pickerReleaseTimeDate: {
        disabledDate: time => {
          return new Date(time).getTime() <= Date.now() - 8.64e7;
        },
      },
      timeRules: {
        time: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change',
          },
        ],
      },
    };
  },
  methods: {
    submitChangeTime() {
      this.$refs.timeForm.validate(valid => {
        if (valid) {
          this.$emit('submitChangeTime', this.timeForm.time);
          this.closeChangeTimeDia();
        }
      });
    },

    closeChangeTimeDia() {
      this.$emit('update:changeTimeVisible', false);
      this.$refs.timeForm.resetFields();
    },
  },
};
</script>
<style lang="scss" scoped>
.audit-info {
  .search-form {
    display: flex;
    justify-content: center;
    ::v-deep .el-form-item {
      display: inline-block;
      margin-right: 10px;
      vertical-align: top;
    }
    ::v-deep .el-input__inner {
      border-radius: 0;
    }
  }
  .search-box {
    background: #fff;
    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 10px;
      margin-right: 20px;
    }
    .search-btn {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 16px;

      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
      }
    }
  }
  .list-box {
    .sub-title {
      color: #333;
      font-size: 14px;
      margin-bottom: 10px;
    }
  }

  .pagination-box {
    text-align: right;
    margin-top: 20px;
    ::v-deep .el-pagination {
      button {
        height: 30px;
        color: #999;
      }
      .el-select {
        .el-input__inner {
          border-radius: 0;
          height: 30px;
        }
      }
      .el-input__inner {
        border-radius: 0;
        height: 30px;
        color: #999;
      }
      .el-select-dropdown__item,
      .el-pagination__jump,
      .el-pagination__total {
        color: #999;
        line-height: 30px;
      }
      .el-pager {
        li {
          border-radius: 0;
          border: 1px solid #d9d9d9;
          line-height: 28px;
          text-align: center;
          margin-left: 10px;
          width: 40px;
          height: 30px;
          color: #999;
          &:first-child {
            margin-left: 0;
          }
          &.active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 20px;
    }
    .el-dialog__footer div {
      display: flex;
      justify-content: center;
      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
      }

      .default-btn {
        background: #fff;
        border: 1px solid #dcdfe6;
        &:hover {
          border-color: #2587ff;
          color: #2587ff;
        }
      }
    }
    .handle-btn {
      display: flex;
      justify-content: center;
      margin-bottom: 16px;
      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
        padding: 0;
        border-radius: 0;
      }

      .default-btn {
        background: #fff;
        border: 1px solid #dcdfe6;
        &:hover {
          border-color: #2587ff;
          color: #2587ff;
        }
      }

      .reset-btn {
        background: #e8efff;
        border: 1px solid #2587ff;
        color: #2587ff;
        margin-left: 20px;
        line-height: 27px;
        &:hover,
        :active {
          background-color: #126edf;
          color: #fff;
        }
      }
    }
  }
}
// 列表重置样式-开始
::v-deep .el-table__header .cell {
  .icon-question {
    height: 18px;
    width: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 50%;
    border: 1px solid #c5c5c5;
    color: #c5c5c5;
    display: inline-block;
    margin-left: 10px;
    &:hover {
      color: #fff;
      background-color: #c5c5c5;
    }
  }
}
::v-deep .el-table__row .cell {
  font-size: 12px;
  white-space: normal;
  padding-left: 6px;
  padding-right: 6px;
  .el-button {
    font-size: 12px;
  }
  .el-input__inner {
    padding: 0 6px;
  }
  .edit-info {
    color: #c0c4cc;
  }
}
::v-deep .el-table--small td,
::v-deep .el-table--small th {
  padding: 6px 0;
}
::v-deep .el-table--small .el-table-column--selection {
  .cell {
    padding-left: 10px;
    padding-right: 10px;
    .el-checkbox__inner {
      border-radius: 0;
    }
  }
}
// 列表重置样式-结束

// dialog 重置样式开始
::v-deep.el-dialog__header {
  background: #f5f5f5;
  height: 40px;
  padding: 0 20px;
  line-height: 40px;
  .el-dialog__headerbtn {
    top: 9px;
  }
  .el-dialog__title {
    font-size: 14px;
  }
}
// dialog 重置样式结束
</style>
